export default __webpack_public_path__ + "static/media/home.06ae06fa.svg";